import styled from "styled-components";
import { Input } from "antd";

export const SettingsContainer = styled.div`
  min-height: 100vh;
  margin-left: 60px; /* Account for collapsed sidebar */
  width: calc(100% - 60px);
  padding: 1.5rem;
`;

export const EditableInput = styled(Input)`
  width: 60px;
  padding: 6px 12px 6px 10px;
  text-align: center !important;
  border-radius: 9999px !important;
  border: 1px solid #d1d5db !important;
  font-size: 12px !important;
  background-color: #ffffff !important;

  .ant-input-number-input {
    text-align: center !important;
    font-size: 12px !important;
    padding: 4px 8px !important;
  }

  .ant-input-number-handler-wrap {
    display: none !important;
  }

  &:hover {
    border-color: #3b82f6 !important;
  }

  &:focus-within {
    border-color: #3b82f6 !important;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;
  }
`;

export const EditableTextInput = styled(Input)`
  padding: 6px 12px;
  text-align: center !important;
  font-family: "Inter", sans-serif !important;
  border-radius: 9999px !important;
  border: 1px solid #d1d5db !important;
  font-size: 12px !important;
  background-color: #ffffff !important;

  &:hover {
    border-color: #3b82f6 !important;
  }

  &:focus {
    border-color: #3b82f6 !important;
    box-shadow: 0 0 0 2px rgba(59, 130, 246, 0.1) !important;
  }
`;
